/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type ApiGuardianRateLimitType = 'Global' | 'IP';

export const ApiGuardianRateLimitType = {
  Global: 'Global' as ApiGuardianRateLimitType,
  IP: 'IP' as ApiGuardianRateLimitType,
};
